import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Logo from 'src/Assets/Images/Branding.svg';
import './styles.scss';
import { footerConstantsCompany } from './footerConstantsCompany';
import { footerConstantsProduct } from './footerConstantsProduct';
import globe from 'src/Assets/Images/global_icon.svg';
import { connect } from 'react-redux';
import {
  loadGeoIPCountry, loadGeoIPCountrySuccess, fetchCountry, fetchCountrySuccess, loadUnauthenticatedSupportFaq
} from 'src/Actions/Support/supportActions';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { changeUnauthlang } from 'src/Utils';


export class Footer extends Component {
  state = {
    dropdown: false,
    open: false,
    checkIcon: false,
  }
  constructor(props) {
    super(props);

    this.countryRefFooter = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.countryRefFooter && !this.countryRefFooter.current.contains(event.target)) {
      this.setState({ dropdown: false })
    }
  }

  handleLinkClick = (tab, e) => {
    const { t } = this.props;
    if (tab === t('support')) {
      this.props.history.push('/support');
    }
  }

  toggleClass = (e) => {
    this.setState((prevState) => {
      return { open: !prevState.open };
    });
    this.setState((prevState) => {
      return { dropdown: !prevState.dropdown };
    });
  };
  setlocalCountry = (countryCode, languageCode, languageName, e) => {
    localStorage.setItem('activeCountry', countryCode + languageCode);
    localStorage.setItem('activeLanguageCountry', languageName +"/"+ countryCode);
    localStorage.setItem('activeLanguage', languageName);
    this.updateLanguageTranslation(languageName);
    this.props.loadUnauthenticatedSupportFaq();
    this.setState((prevState) => {
      return { dropdown: !prevState.dropdown };
    });
    this.setState(() => {
      return { open: false };
    });
  }

  updateLanguageTranslation = (languageName) => {
    const { i18n } = this.props;
    changeUnauthlang(i18n,languageName)
    
  };

  renderCountries = () => {
    let responseCountries = this.props.support.countryList;
    let currentCountry = localStorage.getItem('activeCountry');

    return (
      <>
        <ul className="list__country-dropdown">
          <FontAwesomeIcon icon="fa-solid fa-check" />
          {(responseCountries &&
            responseCountries.map((ob, i) =>
            ((ob.countryCode + ob.languageCode) == currentCountry ? (

              <li className="li__country-dropdown button-li" onClick={(e) => this.setlocalCountry(ob.countryCode, ob.languageCode, ob.languageName, e)} style={{ backgroundColor: '#02536c', border: '0px' }}>

                <li className="sso-text__li" style={{ backgroundColor: '#02536c', paddingLeft: '15px', paddingRight: '15px' }}> {ob.countryName}</li>
              </li>) :
              (
                <li className="li__country-dropdown button-li" onClick={(e) => this.setlocalCountry(ob.countryCode, ob.languageCode, ob.languageName, e)}>

                  <li className="sso-text__li" style={{ paddingLeft: '15px' }} >  {ob.countryName}</li>

                </li>)
            ))
          )}  </ul>

      </>
    )
  }

  renderFooterLinks = (links) => {
    const { t } = this.props;
    return (
      <>
        {links.linkList.map((link, i) => (
          <li className="link-element__footer" key={link.text}>
            <a
              key={link.text}
              {...link.text === t('support') ? {} : { href: link.link }}
              target={link.text === t('support') ? '' : "_blank"}
              onClick={(e) => this.handleLinkClick(link.text, e)}
            >
              {link.text}
            </a>
          </li>
        ))}
      </>
    )
  }

  render() {
    const { t } = this.props;
    const { dropdown, open } = this.state;
    let activeCountry = localStorage.getItem('activeCountry');
    let displayCountry = "";
    let responseCountries = this.props.support.countryList;
    responseCountries.forEach((item) => {
      if ((item.countryCode + item.languageCode) == activeCountry) {
        displayCountry = item.countryName
      }
    })

    return (
      <div className="footer-wrapper">
        <div className="logo-text-container">
          <img src={Logo} />
          <div className='logo-line'></div>
          <span className="logo-text">{t('digitalExpert')}</span>
        </div>
        <div className="links-wrapper">
          <div>
            <section className="links-wrapper__footer_Product">
              <ul className="links-list__footer">
                <li style={{ paddingBottom: 4 }}>{t('product')}</li>
                {this.renderFooterLinks(footerConstantsProduct)}
              </ul>
            </section>
          </div>
          <div>
            <section className="links-wrapper__footer_Company">
              <ul className="links-list__footer">
                <li style={{ paddingBottom: 4 }}>{t('company')}</li>
                {this.renderFooterLinks(footerConstantsCompany)}
              </ul>
            </section>
          </div>
          <div>
            <section className="links-wrapper__footer_Company">
              <span className='country-picker' ref={this.countryRefFooter} >
                <span
                  className={
                    !dropdown
                      ? 'country-icon-text-wrapper hover-hand'
                      : 'country-icon-text-wrapper hover-hand active-toggle-button'
                  }
                  onClick={this.toggleClass}

                >
                  <img className="country-logo" src={globe} />
                  <span className="country-texts-container">
                    <div className="country-text" >{displayCountry}</div>
                  </span>

                  <FontAwesomeIcon icon={open ? 'angle-up' : 'angle-down'} />
                  <div className={dropdown ? 'overlay-clicked' : 'overlay'} />
                </span>
                <div
                  className={
                    !dropdown ? 'country-dropdown' : 'country-dropdown-clicked'
                  }
                >
                  {this.renderCountries()}
                </div>
              </span>
            </section>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ support }) => ({
  support
});
export const mapDispatchToProps = (dispatch) => ({

  loadGeoIPCountry: () => dispatch(loadGeoIPCountry()),
  loadGeoIPCountrySuccess: (list) => dispatch(loadGeoIPCountrySuccess(list)),
  fetchCountry: () => dispatch(fetchCountry()),
  fetchCountrySuccess: (list) => dispatch(fetchCountrySuccess(list)),
  loadUnauthenticatedSupportFaq: () => dispatch(loadUnauthenticatedSupportFaq()),

});
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withRouter(Footer)));
